import {
  WRITE_LOG,
  WRITE_SUPERVISORLOG,
  WRITE_IMPORTANTLOG,
  GET_LOG,
  GET_IMPORTANTLOG,
  GET_SUPERVISORLOG
} from "./logActionTypes";

const logReducer = (state, action) => {
  switch (action.type) {
    case GET_LOG:
      return { ...state, logList: action.payload.notes };
    case GET_IMPORTANTLOG:
      return { ...state, importantList: action.payload.notes }
    case GET_SUPERVISORLOG:
      return { ...state, supervisorList: action.payload.notes }
    case WRITE_LOG:
      return _writeLog(state, action);
    case WRITE_SUPERVISORLOG:
      return _writeSupervisorLog(state, action);
    case WRITE_IMPORTANTLOG:
      return _writeImportantLog(state, action);

    default:
      return state;
  }
};

const _writeLog = (state, action) => {
  var note = {
    author: "You",
    message: `<div>${action.payload}</div>`,
    modified: new Date().toISOString()
  }
  var currentLog = [...state.logList];
  currentLog.splice(0, 0, note);
  return { ...state, logList: currentLog }
}

const _writeSupervisorLog = (state, action) => {
  var note = {
    author: "You",
    message: `<div>${action.payload}</div>`,
    modified: new Date().toISOString()
  }
  var currentLog = [...state.supervisorList];
  currentLog.splice(0, 0, note);
  return { ...state, supervisorList: currentLog }
}

const _writeImportantLog = (state, action) => {
  var note = {
    author: "You",
    message: `<div>${action.payload}</div>`,
    modified: new Date().toISOString()
  }
  var currentLog = [...state.importantList];
  currentLog.splice(0, 0, note);
  return { ...state, importantList: currentLog }
}

export default logReducer;
